module.exports = __webpack_public_path__ + "img/PXL_20230525_120640080.b0525618.jpg";